import { Navigate, useLocation } from 'react-router-dom'
import { AuthState } from 'recoil/atoms/auth.atom'
import { useRecoilState } from 'recoil'
import { Suspense, useEffect } from 'react'
import { Header } from 'components/molecules/Header'
import { LoadingOverlay } from 'components/atoms/overlay/LoadingOverlay'

type Props = { children: JSX.Element }
export const MainPage = (props: Props): JSX.Element => {
  const { children } = props
  const location = useLocation()

  const RouteAuthGuard = (props: { children: React.ReactNode }) => {
    const { children } = props
    const [_, setAuth] = useRecoilState(AuthState)
    const localToken = localStorage.getItem('auth')
    useEffect(() => {
      if (localToken != null) {
        setAuth(JSON.parse(localToken).authorityCode)
      }
    }, [])
    const authUser = localToken != null
    return authUser ? (
      <>{children}</>
    ) : (
      <Navigate to={'/login'} state={{ from: location }} replace={false} />
    )
  }
  const unimplementedPaths = ['/reports', '/contracts']
  const showOverlay = unimplementedPaths.includes(location.pathname)

  return (
    <RouteAuthGuard>
      <div className={'flex min-h-screen min-w-fit flex-col bg-[#f5f6fa]'}>
        <Header />
        <Suspense fallback={<LoadingOverlay />}>
          <div className={'mx-auto w-full max-w-[1400px] px-[30px] py-[30px]'}>
            {children}
          </div>
          {showOverlay && (
            <div
              className={
                'absolute inset-0 z-10 flex items-center justify-center bg-white/80'
              }
            >
              <p className={'text-lg text-gray-500'}>今後、実装予定です。</p>
            </div>
          )}
        </Suspense>
      </div>
    </RouteAuthGuard>
  )
}
